module.exports = __webpack_public_path__ + "42245459bbac1c3eb3a587f3032e6f4c.MP3";